module.exports = __webpack_public_path__ + "static/65-423949da2e1e60fb96f304c1c20ddc8a.png";